if(document.querySelector('#infiniteoptions-container')) document.querySelector('#infiniteoptions-container').classList.add('hidden');
$(document).ready(function() {
  var npi_data = null;
  var selected_doctor = false;
  var form_data = {
    Customer: {
      Gender: null,
      IsPregnant: null,
      DOB: null,
      AllergyText: null,
      MedicalConditionText: null,
      CurrentMedicationsText: null,
      PhoneNumber: null
    },
    Prescription: null
  };

  setTimeout(function() {
    var npi = new Def.Autocompleter.Search(
    'doctor_name-0-0',
    'https://clinicaltables.nlm.nih.gov/api/npi_idv/v3/search?sf=name.first,name.last&df=name.full,provider_type,addr_practice.full&ef=NPI,name,addr_practice&maxList=10000',
    {
      tableFormat: true, 
      valueCols: [0],
      colHeaders: ['Name', 'Type', 'Practice Address']
    });
    Def.Autocompleter.Event.observeListSelections(null, function(e) {
      npi_data = npi.getSelectedItemData();
      selected_doctor = true;
    });

    MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(function(mutations, observer) {
      getDropdownPos();
    });
    observer.observe(document.querySelector('#searchResults'), {
      attributes: true
    });

    function getCookie(cookName) {
      var cname = cookName + "=";
      var deCookie = decodeURIComponent(document.cookie);
      var cookArray = document.cookie.split(';');
      for(var i = 0; i < cookArray.length; i++) {
          var c = cookArray[i];
          while (c.charAt(0) == ' ') {
              c = c.substring(1);
          }
          if (c.indexOf(cname) == 0) {
              return c.substring(cname.length, c.length);
          }
      }
      return "";
    }

    if(getCookie('norx') != "") {
      if(document.querySelector('#infiniteoptions-container')) {
        document.querySelector('.rx-prescription').remove();
        document.querySelector('#infiniteoptions-container').remove();
        var rxObserver = new MutationObserver(function(mutations, observer) {
          document.querySelector('#infiniteoptions-container').remove();
        });
        if (document.querySelector('#infiniteoptions-container')) {
          rxObserver.observe(document.querySelector('#infiniteoptions-container'), {
            attributes: true
          });
        }
      }
    }

    function getDropdownPos() {
      let input_width = $('#doctor_name-0-0').outerWidth();
      let rect = document.querySelector('#doctor_name-0-0').getBoundingClientRect();
      $('#searchResults').css('width', input_width+'px').css('left', rect.left+'px');
    }
    $(window).on('resize', function() {
      getDropdownPos();
    });

    if ($('#infiniteoptions-container').length > 0) {
      $('#addToCart').prop('disabled', true);
      $('#infiniteoptions-container .hide_input input').prop('disabled', true);
      $('.rx-prescription').show();
      $('#infiniteoptions-container').removeClass('hidden');

      let input_change;
      $('#infiniteoptions-container').on('keyup change', 'input, select', function(e) {
        if (input_change !== undefined) {
          clearTimeout(input_change);
        }
        input_change = setTimeout(function(e) {
          if (formIsFilled()) {
            $('#infiniteoptions-container input, #infiniteoptions-container select').each(function(i) {
              let input_name = $(this).attr('name');
              let value = $(this).val();
              if (input_name) {
                if (input_name.includes('date_of_birth')) {
                  form_data.Customer.DOB = value;
                } else if(input_name.includes('gender')) {
                  form_data.Customer.Gender = value;
                } else if(input_name.includes('are_you_pregnant')) {
                  form_data.Customer.IsPregnant = value;
                } else if(input_name.includes('list_allergies')) {
                  form_data.Customer.AllergyText = value;
                } else if(input_name.includes('list_medical_conditions')) {
                  form_data.Customer.MedicalConditionText = value
                } else if(input_name.includes('list_medications')) {
                  form_data.Customer.CurrentMedicationsText = value;
                } else if(input_name.includes('doctor_phone')) {
                  form_data.Customer.PhoneNumber = value;
                }
              }
            });
            $('#addToCart').prop('disabled', false);
          } else {
            $('#addToCart').prop('disabled', true);
          }
        }, 400)
      });
      $('#addToCart').on('click', function(e) {
        e.preventDefault();
        var varid = ($('select[name="id"]').length > 0) ? $('select[name="id"]').find(":selected").val() : $('[name="id"]').val();
        var sku = $('[name="id"]').find(":selected").data('sku');
        form_data.Prescription = {
          NDC: $('#product_ndc').val(),
          NPI: npi_data[0].data.NPI,
          FirstName: (npi_data[0].data.name.first) ? npi_data[0].data.name.first : npi_data[0].data.name.full,
          LastName: (npi_data[0].data.name.last) ? npi_data[0].data.name.last : null,
          Line1: (npi_data[0].data.addr_practice.line1) ? npi_data[0].data.addr_practice.line1 : null,
          City: (npi_data[0].data.addr_practice.city) ? npi_data[0].data.addr_practice.city : null,
          State: (npi_data[0].data.addr_practice.state) ? npi_data[0].data.addr_practice.state : null,
          ZIP: (npi_data[0].data.addr_practice.zip) ? npi_data[0].data.addr_practice.zip : null,
          PhoneNumber: (npi_data[0].data.addr_practice.phone) ? npi_data[0].data.addr_practice.phone : null,
          FaxNumber: (npi_data[0].data.addr_practice.fax) ? npi_data[0].data.addr_practice.fax : null
        }
        jQuery.post('/cart/add.js', {
        items: [
          {
            quantity: $('#quantity').val(),
            id: varid,
            properties: {
              '_prescription information': JSON.stringify(form_data)
            }
          }
        ]
      }).done(function() {
        location.href = '/cart';
      });
      });

      $('#infiniteoptions-container').on('focusout', 'input[required], select[required]', function() {
        if ($(this).attr('name').includes('doctor_name') && !selected_doctor) {
          $(this).val('');
        }
        if (!$(this).val()) {
          $(this).addClass('error');
        } else if ($(this).attr('name').includes('doctor_phone')) {
          if (!validatePhoneNumber($(this).val())) {
            $(this).addClass('error');
          }
        }
      });
      $('#infiniteoptions-container').on('focus', 'input[required], select[required]', function() {
        $(this).removeClass('error');
      });
      $('#infiniteoptions-container').on('keyup', '#doctor_name-0-0', function(e) {
        selected_doctor = false;
      });
    }

    document.getElementById('doctor_phone-0-1').addEventListener('input', function (e) {
      var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    });
    document.getElementById('date_of_birth-0-3').addEventListener('input', function (e) {
      var x = e.target.value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,2})(\d{0,4})/);
      e.target.value = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
    });
    document.getElementById('date_of_birth-0-3').addEventListener('blur', function (e) {
      var x = e.target.value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,2})(\d{0,4})/);
      e.target.value = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + (parseInt(x[3]) > 99 ? x[3].replace(/.*(\d{2})$/, '$1') : x[3]) : '');
      if (!validateDate($('#date_of_birth-0-3').val())) {
        $('#date_of_birth-0-3').addClass('error');
      }
    });

    function validatePhoneNumber(phone){
      var pattern = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
      return pattern.test(phone);
    }

    function validateDate(date){
      var pattern = /(0[1-9]|1[012])[-](0[1-9]|[12][0-9]|3[01])[-](\d{2})$/;
      return pattern.test(date);
    }

    function formIsFilled() {
      let totalInput = 0;
      let totalInputWithValue = 0;
      $('#infiniteoptions-container input, #infiniteoptions-container select').each(function(i) {
        let input_name = $(this).attr('name');
        if (input_name && !input_name.includes('medical_history')) {
          totalInput++;
          if ($(this).val()) {
            if (input_name.includes('doctor_phone')) {
              if (validatePhoneNumber($(this).val())) {
                totalInputWithValue++;
              }
            } else if (input_name.includes('date_of_birth')) {
              if (validateDate($(this).val())) {
                totalInputWithValue++;
              }
            } else {
              totalInputWithValue++;
            }
          }
        }
      });
      return totalInput==totalInputWithValue;
    }
  }, 1500)
});